export const RootTag = 'source';
//# sourceMappingURL=consts.js.map